<template lang="pug">
label.cadastro-checkbox-sn
  input.cadastro-checkbox-sn__input(
    type="checkbox"
    :checked="value"
    @change="$emit('input', $event.target.checked)"
  )
  span.cadastro-checkbox-sn__box
  span.cadastro-checkbox-sn__label S/N
</template>

<script>
export default {
  name: 'CadastroCheckboxSn',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-checkbox-sn {
  align-items: center;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  height: 40px;
  opacity: 0.8;
  padding: 4px 12px;
  white-space: nowrap;
}

.cadastro-checkbox-sn__input {
  display: none;
}

.cadastro-checkbox-sn__box {
  border: 1px solid #eaeaea;
  border-radius: 50%;
  height: 16px;
  width: 16px;
}

.cadastro-checkbox-sn__input:checked + .cadastro-checkbox-sn__box {
  background: #1e174e;
  border-color: #1e174e;
  box-shadow: inset 0 0 0 3px #ffffff;
}

.cadastro-checkbox-sn__label {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  line-height: 1.7;
}
</style>
